// Reactインポート
import React from "react";

import { Helmet, HelmetProvider } from 'react-helmet-async'

// ゲットナビゲータ
import Header from "../components/Header";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import ScrollToTop from "../ScrollToTop";
// スタイルインポート
import "../pages/css/about.scss";
import "../responsive/AboutResponsive.scss";
import "../common.scss";

// メインビジュアル
import headerSubImg from "../img/about-us/about-us.jpg";

// グリッドイメージ
import gridImg from "../img/about-us/grid-pic.png";

// メインビジュアル
import flowerImg from "../img/about-us/flower-img.png";

// メインビジュアル
import aboutImg from "../img/about-us/about-img.jpg";

import { motion } from "framer-motion";

function About() {
	return (
		<>
		<HelmetProvider>
			<Helmet prioritizeSeoTags>
			<meta charset="utf-8" />
			<meta name="viewport" content="width=device-width, initial-scale=1" />
			<meta name="theme-color" content="#005bac" />
			<meta
				name="keywords"
				content="千葉県千葉市web制作,千葉市格安ホームページ制作,千葉市web集客,smartgenz,パドリナアレン,smartgenzとは？"
			/>
			<meta
				name="description"
				content="シンプルな思考の力を利用して、大きな成果を上げる。購入しやすい、イメージしやすい、言葉がわかりやすい、結局のところ、シンプルであることが究極の洗練なのです。物事をシンプルに、わかりやすくすることで、効率よく、より良い結果を得ることができると考えています。簡単に説明すると、「シンプルシンキング」とは、問題の最も重要な要素を特定し、不必要な細部を切り離す能力のことです。そうすることで、望ましい結果を得るための最も効果的な解決策を見出すことができるのです。"
			/>
			<meta property="og:title" content="千葉県千葉市でのホームページ制作ならSmartGenz | 私たちについて" />
			<meta
				property="og:description"
				content="シンプルな思考の力を利用して、大きな成果を上げる。購入しやすい、イメージしやすい、言葉がわかりやすい、結局のところ、シンプルであることが究極の洗練なのです。物事をシンプルに、わかりやすくすることで、効率よく、より良い結果を得ることができると考えています。簡単に説明すると、「シンプルシンキング」とは、問題の最も重要な要素を特定し、不必要な細部を切り離す能力のことです。そうすることで、望ましい結果を得るための最も効果的な解決策を見出すことができるのです。"
			/>
			<meta property="og:type" content="article" />
			<meta property="og:url" content="https://smartgenz.com/about" />
			<meta property="og:image" content="%PUBLIC_URL%/smartgenz.jpg" />
			<meta property="og:site_name" content="千葉県千葉市でのホームページ制作ならSmartGenz | 私たちについて" />
			<meta property="og:locale" content="ja_JP" />
			<link rel="apple-touch-icon" href="%PUBLIC_URL%/smartgenz.jpg" />
			<link rel="manifest" href="%PUBLIC_URL%/manifest.json" />
			<link rel="icon" href="%PUBLIC_URL%/favicon.ico" />
			<link rel="canonical" href="https://smartgenz.com/about" />
			<title>千葉県千葉市でのホームページ制作ならSmartGenz | 私たちについて</title>
			</Helmet>
		</HelmetProvider>
		<motion.div
			className="about"
			initial={{ width: 0 }}
			animate={{ width: "100%" }}
			exit={{ x: window.innerWidth, transition: { duration: 0.1 } }}
		>

			<article className="sub-image">
				<div className="sub-main-image position-about">
					<img
						src={headerSubImg}
						alt="アイテム　｜ ヘッダーイメージ"
					></img>
				</div>
			</article>
			<ScrollToTop />
			<section className="ab-sec-company-profile">
				<div className="sub-sec-company-ttl">
					<div className="borderA"></div>
					<h2 data-desc="事業概要">ABOUT</h2>
					<div className="borderB"></div>
				</div>
				<div className="ab-sec-mission">
					千葉県千葉市を拠点とするSmartGenzは、千葉市内をはじめ全国の起業家、事業主、経営者の皆様からのご依頼を幅広く承っております。
					ブランディングとリードジェネレーションを融合させたWebサイトを構築し、集客やターゲット顧客への商品・サービスの価値を伝えます。
				</div>
				<div className="ab-sec-desc">
					<ul className="ab-sec-desc-table">
						<li>
							<img className="" src={gridImg}></img>
							<div className="table-txt">
								<text>屋号</text>
								<text>SmartGenz (スマートジェンズ)</text>
							</div>
						</li>
						<li>
							<img className="" src={gridImg}></img>
							<div className="table-txt">
								<text>事業内容</text>
								<text>
									WEB・ホームページ制作、
									<br className="spOnly" />
									WEB開発支援、
									<br className="spOnly" />
									WEBデザイン、
									<br className="spOnly" />
									グラフィックデザイン制作（名刺作成、パンフレットデザイン作成等）など
								</text>
							</div>
						</li>
						<li>
							<img className="" src={gridImg}></img>
							<div className="table-txt">
								<text>所在地</text>
								<text>
									千葉県千葉市内（自宅兼用のため、一部省略させていただきます）
								</text>
							</div>
						</li>
						<li>
							<img className="" src={gridImg}></img>
							<div className="table-txt ">
								<text>TEL</text>
								<text className="two-row">
									<a href="tel:043-356-0300">043-356-0300</a>
									<text className="annotation">
										※外出のため、お電話に出れない場合がございます。大変お手数をおかけしますが、メールにて再度お問い合わせください。
									</text>
								</text>
							</div>
						</li>
						<li>
							<img className="" src={gridImg}></img>
							<div className="table-txt">
								<text>MAIL</text>
								<text>
									<a href="mailto:arenpadorina&#64;smartgenz.com">
										arenpadorina@smartgenz.com
									</a>
								</text>
							</div>
						</li>
						<li>
							<img className="" src={gridImg}></img>
							<div className="table-txt">
								<text>共同制作者</text>
								<text>5人（委託者も含む）</text>
							</div>
							<img className="" src={gridImg}></img>
						</li>
						<li>
							<div className="table-txt">
								<text className="wid25">加入団体</text>
								<ul className="client"> 
									<li>千葉商工会議所</li>
								</ul>
							</div>
							<img className="" src={gridImg}></img>
						</li>
					</ul>
				</div>
			</section>
			<section className="ab-sec-company-plan">
				<div className="ab-sec-company-plan-desc">
					<div className="ab-sec-company-plan">
						<img src={flowerImg}></img>
					</div>
					<div className="ab-sec-company-plan-ttl">
						お客様の抱えてる課題点をシンプル
						<br />
						なやり方で解決いたします。
					</div>
					<div className="ab-sec-company-plan-txt">
						私たちはSmartGenzはWeb制作・Web運用保守に困っているお客様を助けるWeb制作事務所です。私たちの最大な強みは第一印象に「DD法則」の活用です。DDの略はDramatic Demonstration（印象的なデモンストレーション）この思考をサイト訪問者へ与えることで興味へと繋がり、お客様の最終的な目標へと繋がります。
						<br />
						これまで約１０社以上のWEB企画・WEB制作を担当して、"お問い合わせが多いサイト"は共通してインパクトが強いサイトがほとんどだと実感しております。
						<br />
						私たちSmartGenzにWEB企画～WEB構築・運用の工程をお任せいただければお客様の最終的なゴールへと繋げられると強く思います。
					</div>
				</div>
				<div className="ab-sec-company-plan-img">
					<img src={aboutImg}></img>
				</div>
			</section>
			<Contact />
			<Footer />
		</motion.div>
		</>
	);
}

export default About;
